query GetCaseRecordAccountingHistory($caseRecordId: ID!) {
  caseRecordAccountingHistory(caseRecordId: $caseRecordId) {
    events {
      occurredAt
      kind
      title
      detail
      journalEntryId
    }
    dataHubLines {
      id
      journalEntryId
      journalEntryType
      journalEntryStatus
      journalEntrySageId
      postingDate
      txnType
      glAccountId
      amount {
        minorUnit
        currency
      }
      description
    }
    sageEntries {
      id
      sageId
      batchTitle
      entryDate
      enteredAt
      accountNumber
      accountTitle
      transactionType
      amount {
        minorUnit
        currency
      }
      linkedToCase
    }
  }
}
